export const handleLoading = (storeLoading, neededLoadingType) => storeLoading.type === neededLoadingType && storeLoading.loading;
